module.exports = __webpack_public_path__ + "img/dirty_lavatory_seat.1c92731e.svg";